export enum TaskStatus { // Should be renamed to TaskStatusResponse
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  QUEUED = "QUEUED",
  SCHEDULED = "SCHEDULED",
  STARTED = "STARTED",
  WARNING = "WARNING",
}

export enum TaskStatusProductLabel {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  QUEUED = "IN PROGRESS",
  PENDING = "TO START",
  STARTED = "IN PROGRESS", //NOSONAR
  SCHEDULED = "TO START", //NOSONAR
  WARNING = "WARNING",
}

export enum TaskType {
  UPLOAD_GAMES = "UPLOAD_GAMES",
  EXPORT_GAMES_CSV = "EXPORT_GAMES_CSV",
  OPERATOR_ALERTS = "OPERATOR_ALERTS",
  MACRO_RECONCILIATION = "MACRO_RECONCILIATION",
  MICRO_RECONCILIATION = "MICRO_RECONCILIATION",
}
